import { Injectable } from "@angular/core";

/**
 * Analytics
 *
 * Thin wrapper over the Google Analytics `gtag` function loaded in
 * `index.html`. Pages and components call this instead of touching
 * `window.gtag` directly, so every booking CTA on the site reports the
 * same event name and parameter shape.
 */
@Injectable({ providedIn: "root" })
export class AnalyticsService {
  /** Record which booking CTA was clicked in Google Analytics. */
  trackBookCta(location: string): void {
    (window as any).gtag?.("event", "book_cta_click", {
      cta_location: location,
    });
  }
}
